module.exports = __webpack_public_path__ + "img/cart.f5b8340.svg";